module.exports = __webpack_public_path__ + "static/media/cricket-ball.5b7dc6b7.svg";